export const DocumentsTypes = {
  file: "DOCUMENT",
  pdf_document: "PDF_DOCUMENT",
  model: "MODEL",
  folder: "DIRECTORY",
  cosmos: "COSMOS_DOCUMENT",
  cosmos_geoserver: "COSMOS_GEOSERVER_DOCUMENT",
} as const;

export const DirectoryTypes = {
  FILE: "DOCUMENT",
  FOLDER: "FOLDER",
} as const;

export type DirectoryType = (typeof DirectoryTypes)[keyof typeof DirectoryTypes];

export interface IDirectoriesResponse {
  contents: IDirectoriesContent[];
  folderId: string;
}

export interface IDirectoriesContent {
  created: number;
  id: string;
  name: string;
  parentFolderId: string;
  projectId: string;
  type: DirectoryType;
}

export interface IDirectories {
  contents: IDirectoriesContent[];
  folderId: string;
}
export interface IFiles {
  contents: IDirectoriesContent[];
  folderId: string;
}

export interface IVerions {
  contents: IDirectoriesContent[];
  fileId: string;
}
